/**
 * Serviceplan MAKEOS
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UserAgencyClientModel } from './userAgencyClientModel';


export interface UserAgencyModel { 
    _id: string;
    name: string;
    clients: Array<UserAgencyClientModel>;
}

